import { Card, CardContent, Chip, Stack, Typography } from "@mui/material";

interface Props {
  scopes?: string[];
}

export default function ChannelScopesSection({ scopes = [] }: Props) {
  return (
    <Card sx={{ boxShadow: 0 }}>
      <CardContent>
        <Typography variant="h6" gutterBottom>
          Scopes
        </Typography>

        <Stack direction="row" spacing={1} useFlexGap flexWrap="wrap">
          {scopes.length > 0 ? (
            scopes.map((scope) => (
              <Chip key={scope} label={scope} variant="outlined" />
            ))
          ) : (
            <Typography color="text.secondary">No scopes available</Typography>
          )}
        </Stack>
      </CardContent>
    </Card>
  );
}
